import React, { useEffect, Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import BranchForm from 'Component/DashboardQeza/Branch/Form';
import { getBranch } from 'Services/Features/Branch/Utils/branchUtils';
import { setFormData, resetFormData } from 'Services/Features/Branch/branchSlice';
import { GetAdminRole } from 'Component/Common/GetAdminRole';

const BranchAdd = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const filters = useSelector(state => state.branch.filters)
    const currentBranch = useSelector((state) => state.branch.currentBranch);
    const operationHoursState = useSelector((state) => state.branch.currentBranch.operation_hours);
    const [refetch, setRefetch] = useState(false);
    const user = JSON.parse(localStorage.getItem('USER'));
    const role = GetAdminRole(user);
    const history = useNavigate();
    if (role !== 'super_admin') {
        if (user.branch_id !== Number(id)) {
            history(`${process.env.PUBLIC_URL}/unauthorized`);
        }
    }

    // console.log(currentBranch, 'currentBranch');
    const initializeOperationHours = (itemHours) => {
        try {
            // Cek apakah itemHours sudah berupa object atau masih string
            if (typeof itemHours === 'string') {
                return { ...operationHoursState, ...JSON.parse(itemHours) };
            } else if (typeof itemHours === 'object' && itemHours !== null) {
                return { ...operationHoursState, ...itemHours };
            } else {
                return { ...operationHoursState };
            }
        } catch (error) {
            console.error("Error parsing operation hours:", error);
            return { ...operationHoursState };
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);

        if (id && !currentBranch?.id) {
            // Buat filter untuk ambil data berdasarkan ID
            const newFilters = {
                ...filters,
                "filter[id]": id,
                page: 1,
            };

            // Fetch data dari API pakai ID
            dispatch(getBranch(newFilters)).then((response) => {
                if (response.payload && response.payload.data?.length > 0) {
                    const item = response.payload.data[0]; // Ambil item pertama (kalau ada)

                    // Simpan photos & banner ke state terpisah
                    dispatch(setFormData({ photosLink: item.photos, bannerLink: item.banner }));

                    // Buat objek baru tanpa photos & banner
                    const { photos, banner, ...updatedItem } = item;

                    dispatch(setFormData({
                        ...updatedItem,
                        operation_hours: initializeOperationHours(item.operation_hours),
                    }));
                }
            });
        } else if (currentBranch?.id) {
            // Kalau nggak ada ID, tapi ada data di state, pakai yang ada
            dispatch(setFormData({
                ...currentBranch,
                operation_hours: initializeOperationHours(currentBranch.operation_hours),
            }));
        } else {
            // Kalau nggak ada ID & data di state, reset form
            dispatch(resetFormData());
        }
    }, [id, refetch]);



    return (
        <Fragment>
            <Breadcrumbs parent="Cabang Klinik" title={id ? 'Edit Cabang Klinik' : 'Tambah Cabang Klinik'} />
            <BranchForm label={id ? "" : "Cabang Baru"} setRefetch={setRefetch} />
        </Fragment>
    );
};
export default BranchAdd;